"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Success = void 0;
var _antd = require("antd");
var _react = _interopRequireDefault(require("react"));
var _success = _interopRequireDefault(require("../components/alert/success"));
var _success2 = _interopRequireDefault(require("../components/input/success"));
var _success3 = _interopRequireDefault(require("../components/message/success"));
var _success4 = _interopRequireDefault(require("../components/notification/success"));
var _success5 = _interopRequireDefault(require("../components/progress/success"));
var _success6 = _interopRequireDefault(require("../components/result/success"));
var _success7 = _interopRequireDefault(require("../components/tag/success"));
var _success8 = _interopRequireDefault(require("../components/timeline/success"));
var _layoutKit = require("@arvinxu/layout-kit");
var Success = exports.Success = function Success(_ref) {
  var id = _ref.id;
  return /*#__PURE__*/_react.default.createElement(_antd.Card, {
    size: 'small',
    id: id
  }, /*#__PURE__*/_react.default.createElement(_layoutKit.Flexbox, {
    horizontal: true,
    align: 'start',
    gap: 24
  }, /*#__PURE__*/_react.default.createElement(_layoutKit.Flexbox, {
    gap: 40
  }, /*#__PURE__*/_react.default.createElement(_layoutKit.Flexbox, {
    horizontal: true,
    align: 'center',
    gap: 12
  }, /*#__PURE__*/_react.default.createElement("div", null, _success7.default.demo), _success2.default.demo), _success.default.demo), /*#__PURE__*/_react.default.createElement(_layoutKit.Flexbox, {
    align: 'center',
    gap: 28
  }, _success3.default.demo, _success5.default.demo)), /*#__PURE__*/_react.default.createElement(_layoutKit.Flexbox, {
    horizontal: true,
    gap: 40,
    style: {
      marginTop: 32
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, _success4.default.demo), /*#__PURE__*/_react.default.createElement("div", null, _success8.default.demo)), _success6.default.demo);
};